import React, { Dispatch } from 'react';
import Translator from '../../core/i18n';
import { IStorageManagementPageProps } from '../../models/pages/storageManagement';
import { FileSections } from '../../models/enums/StorageManagement';
import * as types from '../../models/action/userHome';
import { Log } from 'ng2-logger';
import { IAppState, IAction } from '../../models/action/core';
import { connect } from 'react-redux';
import { SecurityContextType } from '../../models/enums/securityContextType';
import queryString from 'querystring';
import { Common } from '../../core/common';
import * as Actions from '../../store/actions/storageManagement';
import Moment from 'moment';
import Chart from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { Table } from 'reactstrap';
import SortedColumn from '../../components/table/sorted-column';
import imgAnn from '../../static/images/announcement.svg';
import { Redirect } from 'react-router-dom';
import Loading from '../../components/loading/loading';
import ContentLoader from 'react-content-loader';
import ReactGA from 'react-ga4';

const _logger = Log.create('content.tsx');
const T = Translator.create();
const _common = new Common();

export class StoreManagement extends React.Component<IStorageManagementPageProps, any> {
    state = {
        redirectFilePageBySection: "",
    };
    
    divArr : any = [];

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        this.getGeneralStatistics();
    }

    getGeneralStatistics() {
        this.props.dispatch(Actions.GeneralStatistics(
            'getStorageMnagement3',
            'get'
            ));
    }

    convertToGB = (bytesValue: number) => {
        if (bytesValue === 0) return 0;
        return Math.round(bytesValue / Math.pow(1024, 3));
    };

    renderFileSection = (item: any) => {
       
        let FileSection = this.renderFileSectionValue(item);

                this.divArr.push(<div className="legend">
                <span className="legend_small_text">{FileSection}</span>
                <span className="legend_text">{_common.BytesToSize(item.fileSize) + " %" + item.percentage} </span>
            </div>);

            return FileSection;

    };

    renderFileSectionValue = (item: any) => {

        if (item.fileSection == FileSections(T).files_added_activities.value)
        {
            return FileSections(T).files_added_activities.label;
        }
        else if (item.fileSection == FileSections(T).files_added_communication_tools.value)
        {
            return FileSections(T).files_added_communication_tools.label;
        }
        else if (item.fileSection == FileSections(T).personal_files.value)
        {
            return FileSections(T).personal_files.label;
        }
       
            return FileSections(T).other_files.label; 
    };

    fileSection = (item: any, chartStats: any, totalFileSize: any) => {
       
        let fileSizeTypeofGB = Number(_common.BytesToSize(item.fileSize).split(' ')[0]);

                if (item.fileSection == FileSections(T).files_added_activities.value) {
                    chartStats.filesAddedActivities = fileSizeTypeofGB;
                    totalFileSize += item.fileSize;
                } else if (item.fileSection == FileSections(T).files_added_communication_tools.value) {
                    chartStats.filesAddedCommunicationTools = fileSizeTypeofGB;
                    totalFileSize += item.fileSize;
                } else if (item.fileSection == FileSections(T).personal_files.value) {
                    chartStats.personalFiles = fileSizeTypeofGB;
                    totalFileSize += item.fileSize;
                } else {
                    chartStats.otherFiles = fileSizeTypeofGB;
                    totalFileSize += item.fileSize;
                }

                return totalFileSize;

    };


    percentageStatus = (item: any, type: number) => {

        if (item.percentage > 60)
        {
            if (type == 1)
            return 'tag_danger mr-2'
            else if (type == 2)
            return 'progress-bar progress_danger'
            else if (type == 3)
            return 'progress_text_danger'
        }
        else if (item.percentage > 30)
        {
            if (type == 1)
            return 'tag_primary mr-2'
            else if (type == 2)
            return 'progress-bar progress_primary'
            else if (type == 3)
            return 'progress_text_primary'
        }

        else if (item.percentage > 0)
        {
            if (type == 1)
            return 'tag_primary mr-2'
            else if (type == 2)
            return 'progress-bar progress_success'
            else if (type == 3)
            return 'progress_text_success'
        }

        return '';
    
    };

    storageManagementPage(param :any, type :number) {

        if (type == 1)
        return !!(this.props.storageManagementPage && this.props.storageManagementPage.length > 0);
        else if (type == 2)
        return !!(!this.props.storageManagementPage || this.props.storageManagementPage.length<=0);
    }

    percentageValue(param :any) {

       return param.percentage ? param.percentage : '60%' ;
    }

    datasets(data :any) {
        return data.datasets[0].data[0]==undefined  || data.datasets[0].data[0]==0 || data.datasets[0].data[1]==0 || data.datasets[0].data[2]==0 || data.datasets[0].data[3]==0;
     }

    public render() {

        const actionName = 'G_STORAGE_MANAGEMENT_TAKE_ACTION_CLICKED';
        
        let chartStats = {
            "total": 100,
            "filesAddedActivities": 0,
            "personalFiles": 0,
            "filesAddedCommunicationTools": 0,
            "otherFiles": 0
        };

        let totalFileSize = 0;
        if (this.storageManagementPage(this, 1)) {
            this.props.storageManagementPage?.map((item: any) => {

                totalFileSize = this.fileSection(item, chartStats, totalFileSize);
                
            });
        }

        const data = {
            labels: [
                `${T.t('r_files_added_activities')}`,
                `${T.t('r_files_added_communication_tools')}`,
                `${T.t('r_personal_files')}`,
                `${T.t('r_other_files')}`
            ],
            datasets: [
                {
                    data: [
                        this.props.storageManagementPage![0] && this.convertToGB(this!.props!.storageManagementPage![0]!["fileSize"]!),
                        this.props.storageManagementPage![1] && this.convertToGB(this!.props!.storageManagementPage![1]!["fileSize"]!),
                        this.props.storageManagementPage![2] && this.convertToGB(this!.props!.storageManagementPage![2]!["fileSize"]!),
                        this.props.storageManagementPage![3] && this.convertToGB(this!.props!.storageManagementPage![3]!["fileSize"]!),
                    ],
                    backgroundColor: ['#20c997', '#36A2EB', '#FFCE56', '#FF6384'],
                    hoverBackgroundColor: ['#20c997', '#36A2EB', '#FFCE56', '#FF6384']
                }
            ]
        };

        if (this.state.redirectFilePageBySection === FileSections(T).files_added_activities.value) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/files-added-activities'} />
        } else if (this.state.redirectFilePageBySection === FileSections(T).files_added_communication_tools.value) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/files-added-communication-tools'} />
        } else if (this.state.redirectFilePageBySection === FileSections(T).personal_files.value) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/personel-files'} />
        } else if (this.state.redirectFilePageBySection === FileSections(T).other_files.value) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/other-files'} />
        }

        const loadingSpaces = 60;
        this.divArr=[];

        return (
            <div className="student-course  activities-dashboard">
                <div className="container">
                    <div style={{ paddingTop: 0, paddingBottom: 10 }} className="row student-course-header question-filter">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-between">
                                <div>
                                    <h2>{T.t('r_gen_storage_management')}</h2>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 text-md-right">
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                                 
                            <div className="white-box">
                            {(this.datasets(data)) ? (

                                <>
                               <div className="spinner_bg">
                            <div className="donut" />
                            <span className="report_title">{T.t('r_gen_reports_loading')}</span>
                        </div>
                                </>
                            ):
                            (
                                <>
                                <Doughnut
                                data={data}
                                options={{
                                    legend: {
                                        position: 'right'
                                    },
                                    cutoutPercentage: 70
                                }}
                                />
                                <hr />
                                <p className="text-center">
                                    {T.t('r_total_file_size')}: <b>{_common.BytesToSize(totalFileSize)}</b>
                                </p>
                                </>
                                
                            )}

                               
                               
                            </div>
                        </div>
                        <div className="col-md-6 col-12 h-200 pr-0">
                                    {this.storageManagementPage(this , 1) &&
                                        this.props.storageManagementPage?.map((item: any) => {
                                            this.renderFileSection(item);

                                        })
                                      }
                                       {this.divArr.length>0 &&
                                       (
                                        <div className="chart_section">
                                            <div className="chart_legends">{this.divArr}</div>
                                        </div>
                                       )}
                            {this.storageManagementPage(this , 2)&&
                                       <div className="row spinner_bg" >
                                        <div className="donut" />
                                        <span className="report_title">{T.t('r_gen_reports_loading')}</span>
                                        </div>
                           } 
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="page-table helpDesk-table p-0 m-t-0" id="getHelpDesktList_Content">
                          
                                {this.storageManagementPage(this, 1)? (
                                    <Table
                                        className="table-user-list table-striped table-ellipsis table-mobile mt-4"
                                        striped={true}
                                        hover={true}
                                        borderless={true}
                                    >
                                        <thead>
                                            <tr style={{ backgroundColor: '#eaeaea' }}>
                                                <th scope="col" className="text-left">
                                                    {T.t('r_file_sections')}
                                                </th>
                                                <th scope="col" className="text-center">
                                                    {T.t('r_file_size') + " / " + T.t('r_total_size')}
                                                </th>
                                                <th scope="col" className="text-center">
                                                    {T.t('r_occupancy_percentage')}
                                                </th>
                                                <th scope="col" className="text-right">
                                                    <div className="col-md-11">
                                                        {T.t('r_storage_progress')}
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.storageManagementPage?.map((item: any) => {

                                                let FileSection = this.renderFileSectionValue(item);

                                                return (
                                                    <tr
                                                        key={'fileSectionItem-' + item.fileSection}
                                                        data-title={item.fileSection}
                                                        style={{ cursor: 'initial' }}
                                                    >
                                                        <td data-label={T.t('r_file_section')} className="text-left">
                                                            {FileSection}
                                                        </td>
                                                        <td data-label={T.t('r_file_size')} className="text-left">

                                                        {this.percentageStatus(item, 1) != '' &&
                                                         <div className="d-flex align-items-center text-center justify-content-center">
                                                         <span className={this.percentageStatus(item, 1)}>{_common.BytesToSize(item.fileSize) + " / " + _common.BytesToSize(item.totalFileSize)}</span>
                                                        </div>
                                                        }
                                                        </td>
                                                        <td data-label={T.t('r_occupancy_percentage')} className="text-center">
                                                            <div className="progress_tag">
                                                            {this.percentageStatus(item ,2) != '' &&

                                                                <div className="d-flex align-items-center text-center justify-content-center">
                                                                <div className="progress" style={{ width: '100px', minWidth: '100px' }}>
                                                                    <div className={this.percentageStatus(item ,2)}  style={{ width: this.percentageValue(item) }}></div>
                                                                </div>
                                                                <span className={this.percentageStatus(item ,3)}>{item.percentage + "%"}</span>
                                                                </div>
                                                            }
                                                            </div>
                                                        </td>
                                                        <td data-label={T.t('r_storage_progress')} className="text-right">
                                                            <div className="options d-inline-flex align-items-center">
                                                                <button
                                                                    data-toggle="modal"
                                                                    data-target="#preview-question"
                                                                    className="ml-2 category-tag-square tag-green"
                                                                    onClick={() => {
                                                                        ReactGA.event({
                                                                            category: window.location.host,
                                                                            action: actionName,
                                                                            label: actionName, 
                                                                            nonInteraction: true, 
                                                                          });
                                                                        this.setState({ redirectFilePageBySection: item.fileSection })
                                                                    }}
                                                                >
                                                                    {T.t('r_take_action')}
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                            <tr
                                                key={'fileSectionItem-transaction_history'}
                                                data-title={"transaction_history"}
                                                style={{ cursor: 'initial' }}
                                            >
                                                <td data-label={T.t('r_file_section')} className="text-left">
                                                    {T.t('r_transaction_history')}
                                                </td>
                                                <td data-label={T.t('r_file_size')} className="text-center">
                                                </td>
                                                <td data-label={T.t('r_occupancy_percentage')} className="text-center">
                                                </td>
                                                <td data-label={T.t('r_storage_progress')} className="text-right">
                                                    <div className="options d-inline-flex align-items-center">
                                                        <button
                                                            data-toggle="modal"
                                                            data-target="#preview-question"
                                                            className="ml-2 category-tag-square tag-green"
                                                        //onClick={this.onDownload}
                                                        >
                                                            {T.t('r_view')}
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                ) : (
                                    <Loading spinnerId={'getStorageMnagement3'}>
                                    <div style={{ backgroundColor: '#eeede9' }}>
                                        <ContentLoader
                                            speed={2}
                                            backgroundColor="#f3f3f3"
                                            foregroundColor="#ecebeb"
                                            viewBox="0 0 1000 400"
                                            className="course_list_lazy_loader"
                                        >

                                            <rect x="5" y="0" rx="3" ry="3" width="250" height="50" /> 
                                            <rect x="261" y="0" rx="3" ry="3" width="250" height="50" /> 
                                            <rect x="517" y="0" rx="3" ry="3" width="250" height="50" />
                                            <rect x="773" y="0" rx="3" ry="3" width="250" height="50" />

                                            <rect x="5" y={5 + loadingSpaces} rx="3" ry="3" width="250" height="50" /> 
                                            <rect x="261" y={5 + loadingSpaces} rx="3" ry="3" width="250" height="50" /> 
                                            <rect x="517" y={5 + loadingSpaces} rx="3" ry="3" width="250" height="50" />
                                            <rect x="773" y={5 + loadingSpaces} rx="3" ry="3" width="250" height="50" />

                                            <rect x="5" y={5 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" /> 
                                            <rect x="261" y={5 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" /> 
                                            <rect x="517" y={5 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" />
                                            <rect x="773" y={5 + loadingSpaces*2} rx="3" ry="3" width="250" height="50" />


                                          
                                        </ContentLoader>
                                    </div>
 </Loading>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IStorageManagementPageProps) => {
    if (!state) {
        return ownProps;
    }

    const newProps: IStorageManagementPageProps = Object.assign({}, ownProps, {
        storageManagementPage: state.storageManagement.storageManagementPage,
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.storageManagement.storageManagementPage === prev.storageManagement.storageManagementPage;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CStoreManagement = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(StoreManagement);

export default CStoreManagement;

